<template>
    <div class="btnManage">
        <bread-crumb :bread-list="breadList" />
        <div class="info-wrap">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">首页按钮管理</span>
            </div>
            <div class="table-wrap">
                <el-table :data="dataList"
                          stripe
                          v-loading="loading"
                          style="width: 100%">
                    <el-table-column
                        width="70px"
                        label="序号"
                        type="index">
                    </el-table-column>
                    <el-table-column label="按钮名称">
                        <template slot-scope="scope">
                            {{scope.row.menuName}}
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="success"
                                          class="item">
                                </el-badge>
                                <span class="status_text">已上线</span>
                            </div>
                            <div v-else
                                 class="status-warp">
                                <el-badge is-dot
                                          type="info"
                                          class="item">
                                </el-badge>
                                <span class="status_text">未上线</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="图标">
                        <template slot-scope="scope">
                            <el-image v-if="scope.row.menuImage"
                                        class="cover-picture"
                                        :src="'/ms-hoc-video/v1/image/download?fileName='+ scope.row.menuImage">
                            </el-image>
                            <span v-else>暂无</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间">
                        <template slot-scope="scope">
                            {{scope.row.createTime}}
                        </template>
                    </el-table-column>
                    <el-table-column label="排序">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status"
                                 class="status-on">
                                <i class="iconfont icon-paixushang icon-off"
                                   v-if="scope.row.noMoveUp"></i>
                                <i class="iconfont icon-paixushang icon-on"
                                   v-else
                                   @click="moveUpBtn(scope.row)"></i>
                                <i class="iconfont icon-paixuxia icon-off"
                                   v-if="scope.row.noMoveDown"></i>
                                <i class="iconfont icon-paixuxia icon-on"
                                   v-else
                                   @click="moveDownBtn(scope.row)"></i>
                            </div>
                            <div v-else
                                 class="status-off">
                                <i class="iconfont icon-paixushang"></i>
                                <i class="iconfont icon-paixuxia"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span @click="offBtn(scope.row)"
                                  v-if="scope.row.status"
                                  class="link-btn">下线</span>
                            <span @click="onBtn(scope.row)"
                                  v-else
                                  class="link-btn">上线</span>
                            <span @click="editBtn(scope.row)"
                                  class="link-btn">编辑</span>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="pageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="编辑"
                   :visible.sync="isEditShow"
                   custom-class="add-btn-dialog"
                   width="400px">
            <el-form :model="editForm"
                     label-width="80px"
                     ref="editForm">
                <el-form-item label="按钮名称"
                              :rules="[{ required: true, message: '请输入按钮名称'}]"
                              prop="name">
                    <el-input v-model.trim="editForm.name"
                              type="text"
                              placeholder="请输入按钮名称"
                              show-word-limit
                              maxlength="6"></el-input>
                </el-form-item>
                <el-form-item label="图标"
                              class="icon-form-wrap"
                              :rules="[{ required: true, message: '请上传按钮图标'}]"
                              prop="pictureId">
                    <div v-if="editForm.pictureId"
                         class="cover-content">
                        <el-image fit="fill"
                                  class="cover-picture"
                                  :src="'/ms-hoc-video/v1/image/download?fileName='+ editForm.pictureId">
                        </el-image>
                        <i class="iconfont icon-jinggaochacha"
                           @click="handleRemove"></i>
                    </div>

                    <el-upload v-else
                               v-loading="pictureLoading"
                               class="picture-uploader"
                               :action="uploadAction"
                               :show-file-list="false"
                               accept=".jpg, .png"
                               :on-success="handleSuccess"
                               :before-upload="beforeUpload">
                        <div class="picture-content">
                            <i class="iconfont icon-camera"></i>
                            <div class="picture_text">
                                上传图标
                            </div>
                        </div>
                    </el-upload>
                </el-form-item>
                <div class="dialog-btn-wrap">
                    <el-button size="small"
                               type="primary"
                               @click="submitEditForm()">提 交</el-button>
                    <el-button size="small"
                               type="info"
                               plain
                               @click="cancelEditForm()">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<style lang="scss">
.add-btn-dialog {
    .el-dialog__body {
        padding: 24px 20px;
    }
    .el-form-item {
        margin-bottom: 24px;
        &.is-error {
            margin-bottom: 30px;
        }
    }
    .icon-form-wrap {
        .el-form-item__content {
            font-size: 0;
            line-height: 0;
        }
    }

    .dialog-btn-wrap {
        padding: 0 20px 0px 80px;
        text-align: left;
        .el-button {
            width: 96px;
            font-size: 14px;
        }
        .el-button--info.is-plain {
            margin-left: 12px;
            background-color: #f5f5f5;
            border-color: #dbdbdb;
            color: #666;
        }
    }
}
.btnManage {
    .status-warp {
        .el-badge {
            height: 10px;
            .el-badge__content {
                width: 6px;
                height: 6px;
            }
            .el-badge__content--success {
                background: #4acfb1;
            }
            .el-badge__content--info {
                background: #cccccc;
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.info-wrap {
    background-color: #fff;
    box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 20px;
    top: 50px;
    padding: 20px;
    overflow: auto;
}
.title-wrap {
    font-size: 0;
    padding-bottom: 20px;
    height: 16px;
    line-height: 16px;
    .icon-tongyongbiaotiicon {
        color: $color-primary;
        font-size: 16px;
        vertical-align: middle;
    }
    .title-text {
        font-size: 14px;
        color: #333333;
        margin-left: 10px;
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: middle;
    }
}
.table-wrap {
    .table-none {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .icon {
            font-size: 100px;
        }
        span {
            line-height: 14px;
        }
    }
    .link-btn {
        color: $a-link;
        cursor: pointer;
        font-size: 12px;
        display: inline-block;
        height: 14px;
        line-height: 14px;
        border-right: 1px solid $a-link;
        margin-right: 6px;
        padding-right: 6px;
        &:last-child {
            border-right: none;
            margin-right: 0;
            padding-right: 0;
        }
    }
}
.status-warp {
    line-height: 12px;
    .status_text {
        margin-left: 10px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #333333;
        line-height: 12px;
    }
}
.status-on {
    .icon-off {
        color: #ccc;
    }
    .icon-on {
        cursor: pointer;
        color: #3b8fd9;
    }
    .icon-paixuxia {
        font-size: 16px;
    }
    .icon-paixushang {
        font-size: 16px;
        margin-right: 20px;
    }
}
.status-off {
    .icon-paixuxia {
        font-size: 16px;
        color: #ccc;
    }
    .icon-paixushang {
        font-size: 16px;
        color: #ccc;
        margin-right: 20px;
    }
}
.cover-content {
    position: relative;
    .icon-jinggaochacha {
        cursor: pointer;
        font-size: 16px;
        line-height: 16px;
        color: #ec6a69;
        position: absolute;
        top: -8px;
        left: 60px;
    }
}
.cover-picture {
    width: 70px;
    height: 70px;
    .image-slot {
        .el-icon-picture-outline {
            font-size: 70px;
        }
    }
}
.picture-uploader {
    width: 70px;
    height: 70px;
    line-height: 20px;
    background: #d8d8d8;
    text-align: center;
    .picture-content {
        margin-top: 15px;
        .icon-camera {
            font-size: 20px;
            color: #fff;
        }
        .picture_text {
            margin-top: 2px;
            font-size: 12px;
            color: #ffffff;
            line-height: 12px;
        }
    }
}
</style>

<script>
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            applicationId: '52906a03ce45471fb0e4e72f3132d10f', // 树兰的写死
            breadList: [{ label: '运营管理' }, { label: '首页按钮管理' }],
            loading: false,
            dataList: [],
            page: {
                current: 1,
                total: 1,
                pageSize: 10
            },
            editForm: {
                name: '',
                pictureId: ''
            },
            isEditShow: false,
            editData: '',
            pictureLoading: false
        }
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ]),
        uploadAction () {
            return `/ms-hoc-video/v1/image/upload?hospitalId=${this.userInfo.hospitalId}&iuid=${this.userInfo.iuid}&ImageType=BTNICON`
        }
    },
    methods: {
        beforeUpload (file) {
            this.pictureLoading = true
            return true
        },
        handleSuccess (res, file) {
            let data = res.results
            if (data && data.length > 0) {
                this.editForm.pictureId = data[0].originPictureId
                this.$refs['editForm'].clearValidate()
            } else {
                this.$message.error('上传出错，请检查上传图片！')
            }
            this.pictureLoading = false
        },
        handleRemove () {
            this.editForm.pictureId = ''
            this.pictureLoading = false
        },
        editBtn (item) {
            this.editData = item
            this.editForm.name = this.editData.menuName
            this.editForm.pictureId = this.editData.menuImage
            this.isEditShow = true
        },
        submitEditForm () {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    this.postEditForm()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        async postEditForm () {
            const param = {
                menuId: this.editData.menuId,
                menuName: this.editForm.name,
                menuImage: this.editForm.pictureId
            }
            const { results } = await this.$services.btnServices.updateBtn(param)
            this.isEditShow = false
            this.page.current = 1
            this.queryList()
            if (results) {
                this.$message.success('修改成功！')
            }
        },
        cancelEditForm () {
            this.isEditShow = false
        },
        pageChange (value) {
            this.page.current = value
            this.queryList()
        },
        async moveUpBtn (item) {
            const { results } = await this.$services.btnServices.moveUpBtn(item.menuId)
            if (results) {
                this.queryList()
            }
        },
        async moveDownBtn (item) {
            const { results } = await this.$services.btnServices.moveDownBtn(item.menuId)
            if (results) {
                this.queryList()
            }
        },
        async offBtn (item) {
            this.loading = true
            const { results } = await this.$services.btnServices.offBtn(item.menuId)
            this.queryList()
            if (results) {
                this.$message.success('下线按钮成功！')
            }
        },
        async onBtn (item) {
            this.loading = true
            const { results } = await this.$services.btnServices.onBtn(item.menuId)
            this.queryList()
            if (results) {
                this.$message.success('上线按钮成功！')
            }
        },
        async queryList () {
            const param = {
                current: this.page.current,
                size: this.page.pageSize,
                iuid: this.userInfo.iuid,
                hospitalId: this.userInfo.hospitalId,
                applicationId: this.applicationId
            }
            const { results, total } = await this.$services.btnServices.getBtnList(param)
            if (results.length > 0) {
                if (results[0].menuOrder !== 0 && this.page.current === 1) {
                    this.$set(results[0], 'noMoveUp', true)
                }
                if (results[results.length - 1].menuOrder === 1) {
                    this.$set(results[results.length - 1], 'noMoveDown', true)
                }
                this.dataList = results
            }
            this.page.total = total
            this.loading = false
        }
    },
    mounted () {
        this.queryList()
    }
}
</script>
